import { useMemo } from 'react';

import { useAuth } from '@/common/contexts/AuthContext';

const useAside = ({ disabled, isLoading }) => {
  const { user } = useAuth();

  const isDisabled = useMemo(() => {
    const blocked = isLoading || disabled;

    return {
      disabled: blocked,
      loading: isLoading,
      scandit: blocked || !user?.functionality_accesses?.carts_scandit,
      worksite: blocked || !user?.functionality_accesses?.carts_worksite,
    };
  }, [disabled, isLoading, user]);

  return {
    isDisabled,
  };
};

export default useAside;
